import ProfilePicture from "@/components/common/profile-picture";
import { TCommunityMember } from "@/types/community";
import Link from "next/link";

const CommunityMemberCard = ({ member }: { member: TCommunityMember }) => {
	const { image, username, name, isVerified, isFounder } = member;

	return (
		<div className="flex items-center justify-start gap-2 rounded-lg border border-gray-200 p-2">
			<div className="basis-auto">
				<ProfilePicture
					profilePictureUrl={image}
					className={{
						container: "h-10 w-10 rounded-full p-0.5",
						image: "rounded-full text-gray-600",
						badgeImage: "-bottom-3 h-6 w-6",
					}}
					isVerified={isVerified}
					isFounder={isFounder}
				/>
			</div>

			{username ? (
				<Link
					href={`/${username}`}
					className="max-w-xs text-sm font-medium capitalize text-gray-800 md:w-28"
					title={name || ""}
				>
					{name}
				</Link>
			) : (
				<p
					className="max-w-xs text-sm font-medium capitalize text-gray-800 md:w-28"
					title={name || ""}
				>
					{name}
				</p>
			)}
		</div>
	);
};

export default CommunityMemberCard;
